export const EMPLOYEE_TOOLTIP = 'This user is an employee of Hiber';
export const VERIFIED_TOOLTIP = 'This is a verified account';

export const VERIFIED_TAG_NAME = 'verified';
export const EMPLOYEE_TAG_NAME = 'employee';

export const DEVELOPER_TAG_NAME = 'developer';
export const BETATESTER_TAG_NAME = 'betatester';
